



















































































































































































































import { Component, Mixins, Emit, Prop } from "vue-property-decorator";
import { Inquiry, InquiryAnswer } from "@/model/inquiry";

interface AssignableAdmin {
  id: number;
  last_name: string;
  first_name: string;
}
import {
  INQUIRY_STATUS,
  INQUIRY_STATUS_COLOR,
  HOPE_CONTACT_DIV,
  ANSWER_STATUS,
  ANSWER_COMPLETED,
  LISTED_ANSWER_STATUS,
  ANSWER_STATUS_COLOR,
  ANSWER_ASSIGN,
  ANSWER_COMPLETED_UNSOLVED,
  INQUIRY_VERSION,
  INQUIRY_VERSION_COLOR,
} from "@/consts/inquiry";
import UtilMixin from "@/mixins/utilMixin";
import AppAuthButton from "@/components/admin_common/AppAuthButton.vue";
import { sanitizeRichText } from "@/utils/sanitize";
export interface HeaderColumn {
  text: string;
  value: string;
  sortable: boolean;
  align: string;
  width?: string;
  selected?: boolean;
  filterCondition?: number;
  filterType?: number;
  filter?: (val: object) => boolean;
}

/** 表示用Inquiry */
interface DispInquiry extends Inquiry {
  ticket_no: string;
  last_answered_datetime: string;
  first_response_datetime: string;
  co_code: string;
  kst_no: string;
  corresponding_admin_names: string;
  use_receipt_type: number;
  inquiry_date: string;
  inquiry_time: string;
  hope_contact_date: string;
  hope_contact_time: string;
  all_answer_contents: string;
  answer_statuses: number;
  need_mark_hope_contact_date_time: number;
  inquiry_staff_name: string;
  inquiry_staff_furigana: string;
  co_name: string;
  office_name: string;
  is_assignable: boolean;
}

@Component({
  components: {
    AppAuthButton,
  },
})
export default class InProgress extends Mixins(UtilMixin) {
  private sanitizeRichText = sanitizeRichText;

  @Prop({ default: () => [] }) inquirys!: DispInquiry[];
  @Prop({ default: false }) disablePagination!: boolean;
  @Prop({ default: () => [] }) headers!: HeaderColumn[];
  @Prop({ default: () => [] }) sortBy!: [];
  @Prop({ default: () => [] }) sortDesc!: [];
  @Prop({ default: false }) isAssigned!: boolean;
  @Prop({ default: false }) isUnassignMode!: boolean;
  @Prop({ default: () => [] }) selectedInquiries!: DispInquiry[];
  @Prop({ default: () => [] }) displayedInquiries!: DispInquiry[];
  @Prop({ default: false }) disableShowButton!: boolean;
  @Prop({ default: () => [] }) adminUsers!: AssignableAdmin[];

  @Emit("assign-change")
  private emitAssignChange(payload: {
    inquiryId: number;
    adminUserId: number;
    adminUserName: string;
  }) {
    return payload;
  }

  @Emit("update:sortBy") private updateSortBy(value: []) {
    return value;
  }

  @Emit("update:sortDesc") private updateSortDesc(value: []) {
    return value;
  }

  @Emit("update:selectedInquiries") private updateSelectedInquiries(
    value: DispInquiry[]
  ) {
    return value;
  }

  @Emit("update:displayedInquiries") private updateDisplayedInquiries(
    value: DispInquiry[]
  ) {
    return value;
  }

  private get SortBy() {
    return this.sortBy;
  }
  private set SortBy(value) {
    this.updateSortBy(value);
  }

  private get SortDesc() {
    return this.sortDesc;
  }
  private set SortDesc(value) {
    this.updateSortDesc(value);
  }

  private get SelectedInquiries() {
    return this.selectedInquiries;
  }
  private set SelectedInquiries(value) {
    this.updateSelectedInquiries(value);
  }

  private get DisplayedInquiries() {
    return this.displayedInquiries;
  }
  private set DisplayedInquiries(value) {
    this.updateDisplayedInquiries(value);
  }

  private INQUIRY_STATUS = INQUIRY_STATUS;
  private INQUIRY_STATUS_COLOR = INQUIRY_STATUS_COLOR;
  private INQUIRY_VERSION = INQUIRY_VERSION;
  private INQUIRY_VERSION_COLOR = INQUIRY_VERSION_COLOR;
  private ANSWER_STATUS = ANSWER_STATUS;
  private ANSWER_STATUS_COLOR = ANSWER_STATUS_COLOR;
  private HOPE_CONTACT_DIV = HOPE_CONTACT_DIV;
  private LISTED_ANSWER_STATUS = LISTED_ANSWER_STATUS;
  private ANSWER_COMPLETED = ANSWER_COMPLETED;
  private ANSWER_COMPLETED_UNSOLVED = ANSWER_COMPLETED_UNSOLVED;
  private ANSWER_ASSIGN = ANSWER_ASSIGN;

  private get adminUserItems() {
    return this.adminUsers.map((u) => ({
      value: u.id,
      text: `${u.last_name} ${u.first_name}`,
    }));
  }

  private getAssignAdminId(item: DispInquiry): number {
    const assignAnswer = item.inquiry_answers?.find(
      (a) => a.answer_status === this.ANSWER_ASSIGN
    );
    return assignAnswer?.answer_admin_id ?? 0;
  }

  private onAssignAdminChange(item: DispInquiry, adminUserId: number) {
    const admin = this.adminUsers.find((u) => u.id === adminUserId);
    if (!admin) return;
    this.emitAssignChange({
      inquiryId: item.id,
      adminUserId,
      adminUserName: `${admin.last_name} ${admin.first_name}`,
    });
  }

  /** 問い合わせ担当者を取得 */
  private getAdminNames(answers: InquiryAnswer[]): string {
    const adminNames: string[] = [];
    answers.forEach((answer: InquiryAnswer) => {
      if (!adminNames.includes(answer.answer_admin_name)) {
        adminNames.push(answer.answer_admin_name);
      }
    });

    return adminNames.length ? adminNames.join("/") : "";
  }

  private hasAssignAnswer(item: DispInquiry): boolean {
    return (
      item.inquiry_answers?.some(
        (a) => a.answer_status === this.ANSWER_ASSIGN
      ) ?? false
    );
  }

  onToggleSelectAll({ items }: { items: DispInquiry[] }) {
    const allSelectable = items.filter((item) =>
      this.isAssigned
        ? item.is_assignable
        : item.is_assignable && this.hasAssignAnswer(item)
    );
    if (this.SelectedInquiries.length < allSelectable.length) {
      this.SelectedInquiries = allSelectable;
    } else {
      this.SelectedInquiries = [];
    }
  }

  saveCurrentItems(items: DispInquiry[]) {
    // 画面に表示されている順番のアイテム配列が渡される
    this.DisplayedInquiries = items;
  }

  answerStatusColor(answer: {
    answer_status: number;
    is_auto: number;
  }): string {
    if (answer.answer_status === 9 && answer.is_auto === 1) {
      return "green";
    }
    return this.idToText(answer.answer_status, ANSWER_STATUS_COLOR);
  }

  // 詳細ボタンをクリックした場合は親コンポーネントに問い合わせIDを通知
  @Emit()
  show(inquiry: DispInquiry) {
    return inquiry.parent_inquiry_id > 0
      ? inquiry.parent_inquiry_id
      : inquiry.id;
  }
}
